function initiateGifts() {
  const scriptElement = document.querySelector("#data-ajax-freebies")

  if (scriptElement) {
    const jsonString = scriptElement.textContent

    window.cartGiftData = JSON.parse(jsonString)
  }
}

function CartGiftMutation() {
  if (window.cartGiftData) {
    // Get the JSON string from the script's text content
    const cart = window.liquidAjaxCart.cart
    const totalPrice = cart.total_price / 100

    if (cart.item_count === 0) {
      return
    }

    try {
      const gifts = window.cartGiftData

      if (totalPrice <= 0) {
        return {
          requests: [
            {
              type: "clear",
              body: {},
            },
          ],
        }
      }

      // prepare the body for the /cart/update.js request
      const updates = {}

      const totalItemsCount = cart.items.reduce((acc, item) => {
        if (item.price === 0) return acc

        const isPackageProtection = item.sku === "x-redo"
        if (isPackageProtection) return acc

        if (item.properties && item.properties["_add_more_save_more"]) return acc + item.quantity

        return acc
      }, 0)

      window.totalItemsWithoutGift = totalItemsCount

      gifts.freebies.forEach((freebie) => {
        const isInCart = cart.items.some((item) => item.variant_id === freebie.product)
        if (isInCart && freebie.threshold > totalPrice) {
          updates[freebie.product] = 0
        }
      })

      return {
        requests: [
          {
            type: "update",
            body: {
              updates,
            },
          },
        ],
      }
    } catch (error) {
      console.error("Error parsing JSON:")
      return null
    }
  } else {
    console.error("Script element not found or does not have content")
    return null
  }
}

document.addEventListener("liquid-ajax-cart:request-end", (event) => {
  const { requestState } = event.detail

  // If the "add to cart" request is successful
  if (requestState.requestType === "add" && requestState.responseData?.ok) {
    // Add the CSS class to the "body" tag
    const isUpsellOpen = !!document.querySelector(".pre-upsell__wrapper.show")
    if (isUpsellOpen) return

    if (requestState.info?.should_keep_drawer_closed) return
    document.querySelector("cart-drawer").open()
  }
})

initiateGifts()
if (window.liquidAjaxCart?.init) {
  initiateGifts()
}

liquidAjaxCart.conf("updateOnWindowFocus", false)
liquidAjaxCart.conf("mutations", [CartGiftMutation])
